import './rateCard.css';
import React from "react";
import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { PROD } from '../../../common/constants';
import { Helmet } from 'react-helmet-async';
import { Card, Container, Grid, Button, Stack, CardContent, Typography} from '@mui/material';
function RateCard() {

  const navigate = useNavigate();

  return (
    <>
    <Helmet>
      <title> Home | ABEPL </title>
    </Helmet>
    <Container maxWidth="xl">
      <Grid container>
        <Grid item xs={12} lg={12}>        
          <Stack spacing={1}>
          {!PROD && <p className='pageNumberingResc'>RES15</p>}
            <Grid container spacing={1}>
              <Grid item xs={12} lg={6}>
                <Card style={{ borderRadius: 10 }}>
                  <CardContent>
                    <Stack spacing={1}>
                      <Typography variant="h5" sx={{ mb: 2 , fontWeight:'bold', fontSize:'4vh'}}>
                      Add Rate Card
                      </Typography>
                      <Button sx={{ padding: '5px 10px', alignSelf: 'flex-end' }}
                        size="medium"
                        variant="contained"
                        onClick={() => (navigate('createRateCard'))}>Proceed</Button>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} lg={6}>
                <Card style={{ borderRadius: 10 }}>
                  <CardContent>
                    <Stack spacing={1}>
                      <Typography variant="h5" sx={{ mb: 2 , fontWeight:'bold', fontSize:'4vh'}} >
                      View Approved Rates
                      </Typography>
                      <Button sx={{ padding: '5px 10px', alignSelf: 'flex-end' }}
                        size="medium"
                        variant="contained"
                        onClick={() => (navigate('editRateCard'))}>Proceed</Button>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Stack>
        </Grid>
      </Grid>
    </Container>
  </>
  );
}
export default RateCard;
